<template lang="pug">
  div.legend__group
    div(
      :class="className"
    )
      label.label.semibold {{$translate('Место размещения/обращения отходов *')}}
    .search-block
      .legend__small-group
        input.search-block__input.input(
          type="search"
          placeholder="Наименование"
          v-model="query"
          v-debounce:300="searchList"
        )
      ul.search-block__list.reset-list(
        v-if="list.length"
      )
        li.search-block__item.type.custom-checkbox(
          v-for="item in list" :key="'list' + item.id"
        )
          label.custom-checkbox__label.label
            input.custom-checkbox__input.visually-hidden(
              type="checkbox"
              v-model="item.checked"
              @change="(event) => checkItem(event, item)"
            )
            span.custom-checkbox__block
            span.custom-checkbox__text {{item.name}}
</template>

<script>
import { tko } from '@/api/api-endpoints'
import SearchMapMixin from '@/mixins/search-map-mixin'

const PER_PAGE = 10

export default {
  name: 'route-objects',
  mixins: [SearchMapMixin],
  props: {
    className: {
      type: String,
      default: 'legend__type legend__type_with-small',
    },
    objectAddress: {
      type: String,
      default: '',
    },
    objectList: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    query: '',
    list: [],
    checkedList: [],
  }),
  watch: {
    objectList: {
      deep: true,
      handler: 'onObjectItems',
      immediate: true,
    },
  },
  methods: {
    onObjectItems(list) {
      this.checkedList.map((item) => {
        list.forEach((el) => {
          if (el.id === item.id) {
            item.checked = el.checked
          }
        })
      })
    },
    getEndpoint(query) {
      return tko.objects({
        query: {
          q: query,
          'per-page': PER_PAGE,
          fields: 'id, name, longitude, latitude',
        },
      })
    },
  },
  created() {
    this.query = this.objectAddress
  },
}
</script>
